export const DELETE_TEMP_MESSAGE = 'DELETE_TEMP_MESSAGE';
export const FETCH_ARCHIVED_MATCHES = 'FETCH_ARCHIVED_MATCHES';
export const FETCH_ARCHIVED_MATCHES_REQUEST = 'FETCH_ARCHIVED_MATCHES_REQUEST';
export const FETCH_ARCHIVED_MATCHES_SUCCESS = 'FETCH_ARCHIVED_MATCHES_SUCCESS';
export const FETCH_ARCHIVED_MATCHES_ERROR = 'FETCH_ARCHIVED_MATCHES_ERROR';
export const FETCH_CHAT_SUGGESTIONS = 'FETCH_CHAT_SUGGESTIONS';
export const FETCH_CHAT_SUGGESTIONS_REQUEST = 'FETCH_CHAT_SUGGESTIONS_REQUEST';
export const FETCH_CHAT_SUGGESTIONS_SUCCESS = 'FETCH_CHAT_SUGGESTIONS_SUCCESS';
export const FETCH_CHAT_SUGGESTIONS_ERROR = 'FETCH_CHAT_SUGGESTIONS_ERROR';
export const LIKE_MESSAGE = 'LIKE_MESSAGE';
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const SEND_MESSAGE_RETRY = 'SEND_MESSAGE_RETRY';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAILURE = 'SEND_MESSAGE_FAILURE';
export const SET_MATCH_SEEN = 'SET_MATCH_SEEN';
export const SET_MATCH_LIST_EXPIRATION_TOOLTIP_SHOWN = 'SET_MATCH_LIST_EXPIRATION_TOOLTIP_SHOWN';
export const SET_MESSAGE_LIST_EXPIRATION_TOOLTIP_SHOWN =
  'SET_MESSAGE_LIST_EXPIRATION_TOOLTIP_SHOWN';
export const SET_LAST_SEEN_MATCH_MESSAGE = 'SET_LAST_SEEN_MATCH_MESSAGE';
export const SEND_TYPING_PULSE = 'SEND_TYPING_PULSE';
export const RECEIVE_TYPING_PULSE = 'RECEIVE_TYPING_PULSE';
export const TOGGLE_LIKE_MESSAGE = 'TOGGLE_LIKE_MESSAGE';
export const TYPING_INDICATOR_PULSE = 'TYPING_INDICATOR_PULSE';
export const TYPING_INDICATOR_END = 'TYPING_INDICATOR_END';
export const UNLIKE_MESSAGE = 'UNLIKE_MESSAGE';
export const UNMATCH = 'UNMATCH';
export const UNMATCH_SUCCESS = 'UNMATCH_SUCCESS';
export const UNMATCH_FAILURE = 'UNMATCH_FAILURE';
export const MESSAGE_CONSENT_ERROR_CODE = 40302;
export const REQUEST_VERIFICATION_ERROR_CODE = 40381;

export const MATCH_FILTER_ARCHIVED_MATCHES = 'archivedMatches';
export const MATCH_FILTER_WITH_MESSAGES = 'withMessages';
export const MATCH_FILTER_WITHOUT_MESSAGES = 'withoutMessages';

export const CONSENT_SUGGESTIONS = 'consentSuggestions';
export const initialChatSuggestionsState = {
  messageSuggestions: [],
  consentSuggestions: [],
};
